import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CommonServices } from '../services/commonServices';
const commonServices = new CommonServices();

import { Loadingfuction } from '../store/reducers/loading.reducer';
import Image from '../widget/w-image';

interface VerifyProps {}
const VerifyPage: React.FC<VerifyProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [errorMessage, seterrorMessage] = useState('');

  const [licenseDetails, setLicenseDetails] = useState(null);
  const [successMessage, setSuccessMessage] = useState(true);

  useEffect(() => {
    if (
      window.location.pathname.includes('/verified') &&
      sessionStorage.getItem('Details')
    ) {
      const details = sessionStorage.getItem('Details');
      setSuccessMessage(false);
      setLicenseDetails(JSON.parse(details));
      sessionStorage.clear();
    } else if (window.location.pathname.includes('/registration-success') &&
      sessionStorage.getItem('Details')) {
      setSuccessMessage(true);
      sessionStorage.clear();
    } else {
      navigate('/error');
      setSuccessMessage(false);
      sessionStorage.clear();
      seterrorMessage('Page cannot be accessible');
    }
  }, []);

  return (
    <div className='d-flex align-items-center justify-content-center vh-75 w-100'>
      {successMessage ? (
        <div className='d-flex flex-column align-items-center justify-content-center'>
          <div className='text_heding_bold text-center p-2 mb-3'>
            Registration Successful
          </div>
          <Image
            imageClass='loader_css'
            src='\asset\langing_page_icons\verify_hero_icon.svg'
            alt='Loading'
            ariaLabel='Loading'
          ></Image>

          <span className='fw-medium bg-p p-2 rounded-2 mx-2 text_subheding_bold w-75 text-center'>
            Your environment is being set up. You’ll receive an email
            notification once the setup is complete.
          </span>
        </div>
      ) : (
        <>
          {licenseDetails ? (
            <span className='fw-medium bg-p p-2 rounded-2 mx-2 text_subheding_bold w-75 text-center'>
              Your company is already registered with us under the{' '}
              {licenseDetails?.subscription_name} subscription plan. Please
              reach out to your administrator (
              <span
                onClick={() =>
                  window.open(`mailto:${licenseDetails?.admin_id}`, '_blank')
                }
                className='text-primary cursor-pointer text-decoration-underline'
                role='button'
              >
                {licenseDetails?.admin_id}
              </span>
              ) for more information.
            </span>
          ) : (
            <span className='fw-medium bg-p p-2 rounded-2 mx-2 text_subheding_bold w-75 text-center'>
              Your company is already registered with us. Please reach out to
              your administrator for more information.
            </span>
          )}
        </>
      )}
    </div>
  );
};
export default VerifyPage;
